import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';

const CustomAccordion = ({ children, activeKey, onSelect, defaultActiveKey = '0' }) => {
  const isControlled = activeKey != null && activeKey !== '';
  const [internalKey, setInternalKey] = useState(String(defaultActiveKey));
  const currentKey = isControlled ? String(activeKey) : internalKey;

  const handleSelect = key => {
    if (isControlled) {
      onSelect?.(key);
      return;
    }
    setInternalKey(key);
  };

  return (
    <Accordion activeKey={currentKey} onSelect={handleSelect}>
      {React.Children.map(children, (child, index) => (
        <Accordion.Item eventKey={'' + index} id={child?.props?.itemId}>
          <Accordion.Header>{child.props.title}</Accordion.Header>
          <Accordion.Body>{child}</Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

CustomAccordion.propTypes = {
  children: PropTypes.node.isRequired,
  activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
  defaultActiveKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CustomAccordion;
